import SessionSchedulingLayout from 'component/session_scheduling_layout';
import { ReactComponent as Floward } from 'assets/svg/floward.svg';
import { useAuthorize } from 'hooks/useAuthorize';
import { useHistory, useLocation } from 'react-router-dom';
import { PATH } from 'routes/constant';
import { makeStyles } from '@material-ui/styles';
import { useAppDispatch } from '../../../redux/store';
import { resetRequestQuiz, setRequestQuizPath, setSessionSource } from 'redux/style_request_quiz/requestQuiz.slice';
import { REQUEST_PATH, SESSION_QUIZ_PATH } from 'containers/session_quiz/constants';

const startPageStyles = makeStyles({
    floward: {
        marginTop: '30%',
    },
    title: {
        color: '#1A1A1A',
        fontSize: 20,
        fontWeight: 400,
    },
    subText: {
        color: '#1A1A1A',
        fontSize: 18,
        fontWeight: 400,
        margin: '5px 0px',
        fontFamily: 'PoppinsRegular',
    },
});

const GiftCardOnboardStartPage = () => {
    const pageStyles = startPageStyles();
    const authorize = useAuthorize();
    const history = useHistory();
    const location = useLocation();
    const dispatch = useAppDispatch();

    const handleBottomButton = () => {
        if (authorize.isAuthorize) {
            dispatch(resetRequestQuiz());
            dispatch(setSessionSource(location));
            dispatch(setRequestQuizPath(SESSION_QUIZ_PATH.SESSION_PURPOSE));
            history.push(`${PATH.STYLE_REQUEST_QUIZ}/?path=${REQUEST_PATH.SESSION_PURPOSE.param}`);
        } else {
            sessionStorage.setItem('from', JSON.stringify({ from: { path: PATH.STYLE_REQUEST_QUIZ } }));
            authorize.navigateEffect();
            return;
        }
    };

    return (
        <SessionSchedulingLayout bottomButton={{ label: 'Redeem Gift', onClick: handleBottomButton }}>
            <>
                <Floward className={pageStyles.floward} />
                <h1 className={pageStyles.title}>Congratulations!</h1>
                <p className={pageStyles.subText}>
                    You have received a gift of Taffi by someone who cares about you. Click on Redeeem to get your gift.
                </p>
            </>
        </SessionSchedulingLayout>
    );
};

GiftCardOnboardStartPage.whyDidYouRender = true;
export default GiftCardOnboardStartPage;
